<template>
    <section class="bo-card">
        <FormTabHeader
            icon="fal fa-layer-group"
            :title="$t('backoffice_infos.sections.form_types')"
        />
        <div class="bo-body">
            <div
                v-for="type in formTypes"
                :key="type.id"
                class="boft-type"
            >
                <h4 class="boft-type-name">
                    <i class="fal fa-folder"></i>
                    {{ type.name }}
                </h4>
                <div class="boft-forms">
                    <div
                        v-for="form in getFormsByType(type.id)"
                        :key="form.id"
                        class="boft-form-row"
                    >
                        <div class="boft-form-info">
                            <router-link
                                :to="`/forms/${form.id}`"
                                class="boft-form-name"
                            >
                                {{ form.name }}
                            </router-link>
                            <span class="boft-form-count">
                                {{ form.counts ? form.counts.posts : 0 }} {{ $t('backoffice_infos.summary.tickets').toLowerCase() }}
                            </span>
                        </div>
                        <router-link
                            :to="`/forms/${form.id}`"
                            class="bo-action-btn"
                        >
                            <i class="fal fa-eye"></i>
                            {{ $t('form_types.view') }}
                        </router-link>
                    </div>
                    <p
                        v-if="getFormsByType(type.id).length === 0"
                        class="bo-empty"
                    >
                        {{ $t('backoffice_infos.no_forms') }}
                    </p>
                </div>
            </div>
            <p v-if="formTypes.length === 0" class="bo-empty bo-empty--center">
                {{ $t('backoffice_infos.no_form_types') }}
            </p>
        </div>
    </section>
</template>

<script>
import FormTabHeader from '@/components/Model/Form/FormComponents/FormTabHeader'

export default {
    name: 'BackofficeFormTypes',
    components: { FormTabHeader },
    props: {
        forms: { type: Array, required: true },
        formTypes: { type: Array, required: true }
    },
    methods: {
        getFormsByType(typeId) {
            return this.forms.filter((f) => f.type && f.type.id === typeId)
        }
    }
}
</script>

<style scoped>
.bo-card {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
}

.bo-body {
    padding: var(--v2-space-4) var(--v2-space-5);
    display: flex;
    flex-direction: column;
    gap: var(--v2-space-4);
}

.boft-type-name {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 10px;
    font-size: var(--v2-text-sm-size);
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-primary);
    letter-spacing: -0.005em;
}

.boft-type-name i {
    font-size: 0.85rem;
}

.boft-forms {
    padding-left: 20px;
    border-left: 2px solid var(--v2-border-subtle);
    display: flex;
    flex-direction: column;
}

.boft-form-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--v2-space-3);
    padding: 10px 0;
    border-bottom: 1px solid var(--v2-border-subtle);
}

.boft-form-row:last-child {
    border-bottom: none;
}

.boft-form-info {
    display: flex;
    align-items: baseline;
    gap: 10px;
    flex-wrap: wrap;
    min-width: 0;
}

.boft-form-name {
    font-size: var(--v2-text-sm-size);
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    text-decoration: none !important;
    transition: color var(--v2-transition-fast);
}

.boft-form-name:hover {
    color: var(--v2-primary);
}

.boft-form-count {
    font-size: 0.72rem;
    color: var(--v2-text-3);
    font-weight: var(--v2-font-weight-medium);
    font-variant-numeric: tabular-nums;
}

.bo-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 28px;
    padding: 0 10px;
    border-radius: var(--v2-radius-sm);
    font-size: 0.72rem;
    font-weight: var(--v2-font-weight-semibold);
    background: transparent;
    border: 1px solid var(--v2-border);
    color: var(--v2-text-2);
    text-decoration: none !important;
    cursor: pointer;
    transition: all var(--v2-transition-fast);
    flex-shrink: 0;
}

.bo-action-btn i {
    font-size: 0.72rem;
}

.bo-action-btn:hover {
    border-color: var(--v2-primary);
    color: var(--v2-primary);
    background: var(--v2-primary-soft);
}

.bo-empty {
    margin: 0;
    padding: 10px 0;
    font-size: var(--v2-text-xs-size);
    color: var(--v2-text-4);
    font-style: italic;
}

.bo-empty--center {
    text-align: center;
    padding: var(--v2-space-4);
}

@media (max-width: 768px) {
    .bo-body {
        padding: var(--v2-space-3) var(--v2-space-4);
    }

    .boft-form-row {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }

    .bo-action-btn {
        align-self: flex-start;
    }
}
</style>
